import { createContext, Dispatch, useMemo, useState } from 'react';
import { BookmarkItem, GetBookmarks } from './storage-repository';


export const BookmarksContext = createContext(
    {
        bookmarks: [] as BookmarkItem[],
        setBookmarks: (() => undefined) as Dispatch<any>
    }
);